import React from 'react'

export default function Heading({ className, ...props }) {
  return (
    <div className={`text-xl md:text-3xl text-black font-bold ${className}`}>{props.children}</div>
  )
}
